import { render, staticRenderFns } from "./checkWechat.vue?vue&type=template&id=6e062932&scoped=true&"
import script from "./checkWechat.vue?vue&type=script&lang=js&"
export * from "./checkWechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e062932",
  null
  
)

export default component.exports